import { FABRIC_CATALOG_SEED, MATERIAL_CATALOG_SEED } from './catalog.seed';
/**
 * Registry in-memory do catálogo.
 * Inicializado a partir do seed; futuramente hidratado pelo CatalogRepository
 * (IndexedDB) para permitir edição pelo usuário.
 */
class MaterialRegistry {
    materials = new Map();
    fabrics = new Map();
    constructor() {
        this.hydrate(MATERIAL_CATALOG_SEED, FABRIC_CATALOG_SEED);
    }
    hydrate(materials, fabrics) {
        this.materials.clear();
        this.fabrics.clear();
        materials.forEach((m) => this.materials.set(m.id, m));
        fabrics.forEach((f) => this.fabrics.set(f.id, f));
    }
    getMaterial(id) {
        return this.materials.get(id);
    }
    getFabric(id) {
        return this.fabrics.get(id);
    }
    listMaterials(filter) {
        const all = Array.from(this.materials.values());
        if (!filter)
            return all;
        return all.filter((m) => !filter.categoria || m.categoria === filter.categoria);
    }
    listFabrics(filter) {
        const all = Array.from(this.fabrics.values());
        if (!filter)
            return all;
        return all.filter((f) => !filter.uso || f.uso === filter.uso || f.uso === 'top-and-side');
    }
}
export const materialRegistry = new MaterialRegistry();
